/*
SELECT CONCAT(CASE WHEN i.Code LIKE '[0-9]%' THEN '_' ELSE '' END + CAST(i.Code as varchar(max)), ': ', '"',  CAST(i.Code as varchar(max)), '"', ',')
FROM MuellerHomeowner.dbo.InspectionTypeGroups i
ORDER BY CASE WHEN i.Code LIKE '[0-9]%' THEN '_' ELSE '' END + CAST(i.Code as varchar(max))
*/

export const surveyTypeGroupCodes = {
  _1004_DESKTOP: "1004_DESKTOP",
  _1004_HYBRID: "1004_HYBRID",
  _1004D: "1004D",
  CLAIM: "CLAIM",
  COMMERCIAL_EXT: "COMMERCIAL_EXT",
  COMMERCIAL_INT: "COMMERCIAL_INT",
  ELITE_HIGH_VALUE: "ELITE_HIGH_VALUE",
  FARM: "FARM",
  FR_OTHER_APPT: "FR_OTHER_APPT",
  FR_SELECT_APPT: "FR_SELECT_APPT",
  FR_SELECT_ETA: "FR_SELECT_ETA",
  FR_SELECT_EXT: "FR_SELECT_EXT",
  HIGH_VALUE: "HIGH_VALUE",
  LENDER: "LENDER",
  LENDER_COMMERCIAL: "LENDER_COMMERCIAL",
  MVALUE: "MVALUE",
  MVALUE_I: "MVALUE_I",
  MVALUE_I_SUPP: "MVALUE_I_SUPP",
  MVALUE_SUPP: "MVALUE_SUPP",
  OTHER: "OTHER",
  PROBLEM: "PROBLEM",
  RESEDENTIAL_EXT: "RESEDENTIAL_EXT",
  RESEDENTIAL_INT: "RESEDENTIAL_INT",
  RUSH: "RUSH",
  SINKHOLE: "SINKHOLE",
  VIRTUAL: "VIRTUAL",
  WIND: "WIND",
};